import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import VendorDesignsTable from './VendorDesignsTable';
import VendorDesignEditView from './VendorDesignEditView';

const VendorDesignsView = () => (
  <Routes>
    <Route element={<VendorDesignEditView />} path="/new" />
    <Route element={<VendorDesignEditView />} path="/:pkEcomVendorDesign" />
    <Route
      element={<VendorDesignEditView duplicate />}
      path="/:pkEcomVendorDesign/duplicate"
    />
    <Route element={<VendorDesignsTable />} path="/" />
    <Route element={<Navigate replace to="/vendor/designs" />} path="*" />
  </Routes>
);

export default VendorDesignsView;
